import React from "react";
import RoleCommon from "./RolesMain";
import { membersData } from "../mockdata";
import { columnHeader } from "../Team/teamConfig";
import { Container, Row, Col } from "reactstrap";

const Team = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Roles and Permissions</h3>
        <h3 className="page-subhead subhead">
          You can change and modify user privileges in this section.
        </h3>
      </Col>
    </Row>
    <RoleCommon data={membersData} title="Roles" columnHeader={columnHeader} />
  </Container>
);

export default Team;
